import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  Card,
  CardContent,
  Grid,
  makeStyles,
  createStyles,
  Theme,
  IconButton,
} from '@material-ui/core';
import { EmeraldButton } from '@emerald-react/button';
import LinkIcon from '../../../icons/LinkIcon';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridItemCard: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      marginBottom: '0', // Remove margin to let Grid spacing handle the gap
      '& nav': {
        display: 'flex',
      },
    },
    gridItemCardResponsive: {
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        marginBottom: '10px',
        width: '100%',
      },
    },
    editBtnStyle: {
      marginRight: '10px',
      marginTop: '10px',
    },
    editBtnResponsive: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    gridItemCardContent: {
      flex: 1,
    },
    // Removed spaceBetween, not needed with Grid spacing
    iconButton: {
      width: '96px',
      height: '36px',
      color: theme.palette.text.primary,
      borderRadius: '3px',
      fontSize: '16px',
      '& svg': {
        marginRight: '5px',
      },
    },
    descriptionText: {
      marginBottom: '10px',
    },
    rightAlignItem: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    totalDownloads: {
      fontWeight: 'bold',
    },
  }),
);

export function UIUXCard() {
  const classes = useStyles();
  const { entity } = useEntity();
  const onClickStorybook = () => {
    if (entity?.metadata?.homepage) {
      window.open(entity?.metadata?.homepage, '_blank');
    }
  };

  return (
    <>
      <Grid container spacing={2} alignItems="stretch">
        {/* Left Side */}
        

        <Grid item xs={12} md={12} style={{ display: 'flex' }}>
          <Card className={classes.gridItemCard} style={{ flex: 1 }}>
            <CardContent className={classes.gridItemCardContent}>
              <div>
                <div>
                  Latest Version: {entity?.metadata?.latestversion || '0.0.0'}
                </div>
                <div className={classes.totalDownloads}>
                  Total downloads: {entity?.metadata?.downloadcount || '0.0'}
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}